var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 68,
    viewBox: "0 0 182 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2153 41.7407V22.2344H65.9958V41.7407H61.2153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.96 41.7407V22.2344H113.053L121.46 34.158V22.2344H126.048V41.7407H121.955L113.548 29.8171V41.7407H108.96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.6 41.7407V22.2344H133.381V41.7407H128.6Z",
    fill: "#CC214F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.385 41.7407L143.105 22.2344H148.188L155.908 41.7407H150.962L149.589 37.9493H141.539L140.165 41.7407H135.385ZM142.995 33.9382H148.133L145.55 26.8225L142.995 33.9382Z",
    fill: "#CC214F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3752 27.1719L28.0524 40.9062L47.9866 40.9062L45.7971 37.5225",
    stroke: "#CC214F",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1375 33.459L42.5045 32.4808L41.6551 31.2028",
    stroke: "#CC214F",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7812 24.875C40.7812 26.5836 39.3961 27.9688 37.6875 27.9688C35.9789 27.9688 34.5938 26.5836 34.5938 24.875C34.5938 23.1664 35.9789 21.7812 37.6875 21.7812C39.3961 21.7812 40.7812 23.1664 40.7812 24.875ZM36.7781 24.875C36.7781 25.3773 37.1852 25.7844 37.6875 25.7844C38.1898 25.7844 38.5969 25.3773 38.5969 24.875C38.5969 24.3727 38.1898 23.9656 37.6875 23.9656C37.1852 23.9656 36.7781 24.3727 36.7781 24.875Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3294 33.4265L85.6729 41.7296H80.4636L77.5661 34.318H74.0205V41.7296H69.2837V22.252H79.1822C82.4977 22.252 85.2284 24.9547 85.2284 28.2703C85.2257 29.3057 84.9578 30.3233 84.4503 31.2259C83.9429 32.1285 83.2127 32.8861 82.3294 33.4265ZM80.4622 28.2717C80.4583 27.933 80.322 27.6093 80.0826 27.3699C79.8431 27.1304 79.5194 26.9941 79.1807 26.9902H74.0205V29.5816H79.1822C79.8788 29.5816 80.4636 28.9963 80.4636 28.2717H80.4622Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.626 31.9497C106.628 33.26 106.371 34.5577 105.87 35.7685C105.369 36.9793 104.635 38.0795 103.708 39.0061C102.782 39.9326 101.681 40.6673 100.471 41.1682C99.2598 41.669 97.9621 41.9261 96.6518 41.9248C91.1629 41.9248 86.6768 37.4666 86.6768 31.9497C86.6768 26.4607 91.1605 21.9746 96.6518 21.9746C102.169 21.9746 106.626 26.4607 106.626 31.9497ZM101.89 31.9497C101.891 31.2616 101.756 30.5801 101.493 29.9442C101.23 29.3083 100.844 28.7306 100.358 28.244C99.871 27.7574 99.2932 27.3716 98.6573 27.1086C98.0214 26.8457 97.3399 26.7107 96.6518 26.7114C93.7818 26.7114 91.4136 29.0521 91.4136 31.9497C91.4136 34.8472 93.7818 37.1879 96.6518 37.1879C97.3399 37.1887 98.0214 37.0537 98.6573 36.7907C99.2932 36.5278 99.871 36.1419 100.358 35.6554C100.844 35.1688 101.23 34.591 101.493 33.9552C101.756 33.3193 101.891 32.6378 101.89 31.9497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.9808717a97abef54826ce297b0416593.svg";
export { ForwardRef as ReactComponent };